// Campi del PDF del preventivo che si possono togliere nella finestra di
// stampa [sc-49299]. Spec: barcio-api docs/superpowers/specs/
// 2026-10-30-sc-49299-finestra-stampa-design.md
//
// Restano sempre stampati: intestazione Barcio, nome del cliente, descrizione
// e quantità degli articoli, totale articoli, sconto o maggiorazione, totale
// preventivo e totale da pagare.

export const GRUPPI_STAMPA = [
  {
    titolo: "Dettaglio cliente",
    // sempre stampati: in finestra con la spunta fissa
    fissi: ["Nome cliente"],
    campi: [
      { chiave: "telefono", label: "Telefono" },
      { chiave: "contatto", label: "Email / PEC" },
      { chiave: "partitaIva", label: "Partita IVA" },
      { chiave: "codiceFiscale", label: "Codice fiscale" },
      { chiave: "azienda", label: "Azienda" },
      { chiave: "codiceUnivoco", label: "Codice univoco" },
      { chiave: "indirizziCliente", label: "Indirizzi del cliente" },
    ],
  },
  {
    titolo: "Dettaglio preventivo",
    campi: [
      { chiave: "data", label: "Data" },
      { chiave: "metodoPagamento", label: "Metodo di pagamento" },
      { chiave: "indirizzoConsegna", label: "Indirizzo di consegna" },
      { chiave: "mappa", label: "Link alla mappa" },
    ],
  },
  {
    titolo: "Tabella articoli",
    fissi: ["Descrizione e quantità"],
    campi: [
      { chiave: "colCodice", label: "Codice" },
      { chiave: "colUm", label: "Unità di misura" },
      { chiave: "colListino", label: "Prezzo listino" },
      { chiave: "colScontato", label: "Prezzo scontato" },
      { chiave: "colIva", label: "IVA" },
      { chiave: "colImporto", label: "Importo ivato" },
    ],
  },
  {
    titolo: "Riepilogo",
    fissi: ["Totali, sconto e maggiorazione"],
    campi: [
      { chiave: "imponibileIva", label: "Imponibile e IVA" },
      { chiave: "spese", label: "Spese aggiuntive" },
      { chiave: "acconti", label: "Acconti uno per uno" },
    ],
  },
  {
    titolo: "Fondo pagina",
    campi: [
      { chiave: "datiBancari", label: "Dati bancari" },
      { chiave: "firma", label: "Firma" },
      { chiave: "note", label: "Note" },
      { chiave: "clausole", label: "Clausole di giacenza" },
    ],
  },
];

export const CHIAVI_STAMPA = GRUPPI_STAMPA.flatMap((g) =>
  g.campi.map((c) => c.chiave)
);

/** Tutti i campi selezionati: la finestra parte così, e i PDF automatici. */
export function tuttiICampi() {
  return Object.fromEntries(CHIAVI_STAMPA.map((k) => [k, true]));
}

/** Il campo va stampato? Un campo sconosciuto o assente vale «sì». */
export function stampa(campi, chiave) {
  return !campi || campi[chiave] !== false;
}

/**
 * [sc-49299] Clausole di giacenza: testo PROVVISORIO, da sostituire con
 * quello definitivo di Alessandra. È l'unico punto da cambiare.
 */
export const CLAUSOLE_GIACENZA = {
  titolo: "Clausole di giacenza",
  testo:
    "La merce resta in deposito gratuito presso il nostro magazzino per 30 giorni " +
    "dalla data di disponibilità comunicata. Trascorso tale periodo potranno essere " +
    "addebitati costi di giacenza. [Testo provvisorio: da sostituire con quello definitivo.]",
};
